import { createModule } from '@evyweb/ioctopus';

import { couponStoreService, requestCacheService, socketService } from '../../infrastructure/entry.browser.js';
import { diSymbolMap } from '../types.js';

/**
 * Creates and configures the Infrastructure module for framework specific implementation that needs to interact with framework layer.
 *
 * @returns The configured Infrastructure module.
 */
export function createInfrastructureModule(): ReturnType<typeof createModule> {
  const infrastructureModule = createModule();

  // Services
  infrastructureModule.bind(diSymbolMap.ICouponZustandStoreService).toHigherOrderFunction(couponStoreService);
  infrastructureModule.bind(diSymbolMap.ISocketService).toHigherOrderFunction(socketService);
  infrastructureModule.bind(diSymbolMap.IRequestCacheService).toHigherOrderFunction(requestCacheService);

  return infrastructureModule;
}
